/* ═══════════════════════════════════════════════════════════════
   CustomWidgetService — user-built dashboard widgets (Project Center
   widget builder, T5 backend). Same personal-until-shared shape as
   DashboardViewService: `definition` round-trips via cache's jsonFields
   opt, cache.save/remove already fire 'specforma-sync-complete'.
   ═══════════════════════════════════════════════════════════════ */

import type { CustomWidget } from '../../shared/entities';
import * as cache from './cloudCache';

const TABLE = 'custom_widgets';
const opts = { jsonFields: ['definition'] };

export const CustomWidgetService = {
  /** All widgets for a surface — own + shared. Server already filters out
   *  other users' unshared rows (filterCustomWidgets), so no client-side
   *  owner check is needed here. */
  list: async (surface: string): Promise<CustomWidget[]> => {
    const all = await cache.list<CustomWidget>(TABLE, opts);
    return all.filter((w) => w.surface === surface);
  },

  save: async (widget: CustomWidget): Promise<CustomWidget> => cache.save(TABLE, widget, opts),

  delete: async (id: string): Promise<void> => cache.remove(TABLE, id),
};
